export default {"src":"/_next/static/media/CRK.7a12369b.svg","height":18,"width":18};